<template>
  <div class="wapper">
    <div class="team mid-width">
      <img src="./team_banner.png" width="100%">
      <ul class="team_wrapper">
        <li v-for="item in teamList" :key="item.index" class=" clearfix">
          <div class="team-item-left fl">
            <img class="avatar" :src="item.headImg">
            <p class="name">
              {{item.name}}&nbsp; |&nbsp;
              {{item.phone}}&nbsp; |&nbsp;
              <span class="showCode">二维码
                <img class="wxQrCode" :src="item.wxQrCode" alt="">
              </span>
              <!-- <img src="./qr_code.png" style="width: 25px; height: 25px; margin-top: 10px;"> -->
            </p>
            <!-- <div class="contact clearfix">
              <span class="floatLeft">电话：{{item.phone}}</span>
              <span class="floatRight">微信：{{item.wxNumber}}
                <img class="wxQrCode" :src="item.wxQrCode" alt="">
              </span>
            </div> -->
          </div>
          <div class="text fr" style="visibility: visible;">
              <div class="introduce" v-if="item.introduce">
                <p class="title">· 个人介绍</p>
                <div v-html="item.introduce"></div>
              </div>
              <div v-if="item.majorExperience">
                <p class="title mt">· 专业及经验</p>
                <div v-html="item.majorExperience"></div>
              </div>
              <div v-if="item.virtue">
                <p class="title mt">· 个人擅长</p>
                <div v-html="item.virtue"></div>
              </div>
          </div>
        </li>

      </ul>
      <button class="btn loadMore" @click="loadMore" v-show="currentPage !== totalPage">{{moreText}}</button>
    </div>
  </div>
</template>

<script>
import Api from '@/common/api/api'
export default ({
  data () {
    return {
      teamList: [],
      currentPage: 1,
      totalPage: 0,
      isClick: false,
      moreText: '加载更多'
    }
  },
  created () {
    this.teamData()
  },
  methods: {
    teamData () {
      Api.lawyerTeam({
        page: this.currentPage,
        limit: 3
      }).then((response) => {
        console.log(response)
        if (response.data.code === 0) {
          response.data.page.list.forEach(element => {
            this.teamList.push(element)
          })
          console.log(this.teamList)
          this.currentPage = response.data.page.currPage
          this.totalPage = response.data.page.totalPage
        }
        this.moreText = '加载更多'
        this.isClick = false
      })
        .catch((error) => {
          console.log(error)
        })
    },
    loadMore () {
      if (!this.isClick) {
        this.isClick = true
        this.currentPage++
        this.moreText = '加载中'
        this.teamData()
      }
    }

  }
})
</script>

<style lang="scss" scoped>
@import '~@/common/css/common';
.wapper {
  padding-bottom: 40px;
}
.team {
  .team_wrapper {
    font-size: 14px;
    color: #333;
    line-height: 28px;
    margin-top: 25px;
    li {
      box-sizing: border-box;
      padding: 20px 0;
      border-bottom: 1px solid #e4e4e4;
      margin-bottom: 20px;
      .team-item-left {
        float: left;
        width: 308px;
        .avatar {
          width: 308px;
          height: 308px;
          text-align: center;
          border-radius: 50%;
        }
        .name {
          text-align: center;
        }
        .showCode {
          position: relative;
          cursor: pointer;
          img {
            display: none;
            // display: block;
            position: absolute;
            right: 55px;
            // top: -140px;
            top: 30px;
            width: 120px;
            height: 120px;
          }
          &:hover {
            img {
              display: block;
            }
          }
        }

      }
      .text {
        float: right;
        width: 800px;
        padding-top: 5px;
        font-size: 14px;
        .introduce p{
          text-indent: 0;
        }
        .title {
          color: #333;
          font-weight: bold;
          font-size: 15px;
          text-indent: 0;
          &.mt{
            margin-top: 30px;
          }
        }
      }
      p {
        text-indent: 2em;
      }
    }
  }
  .loadMore {
    font-size: 14px;
    border: 1px solid #20A0FE;
    color: #20A0FE;
    font-weight: bold;
    display: block;
    margin: 30px auto 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/team/team.vue